export type StateType = {
  isMajorMenuOpen: boolean
  isSecondaryMenuOpen: boolean
  isDropdowMenuOpen: boolean
  isLogoHidden: boolean
  isBurgerOpen: boolean
  isShopNotificationOpen: boolean
}

export enum HeaderActionType {
  HANDLE_LOGO_HIDDEN = 'HANDLE_LOGO_HIDDEN',
  HANDLE_DROPDOWN_CLOSE = 'HANDLE_DROPDOWN_CLOSE',
  HANDLE_MAJOR_OPEN = 'HANDLE_MAJOR_OPEN',
  HANDLE_SECONDARY_OPEN = 'HANDLE_SECONDARY_OPEN',
  HANDLE_SHOP_NOTIFICATION_OPEN = 'HANDLE_SHOP_NOTIFICATION_OPEN',
  HANDLE_SHOP_NOTIFICATION_CLOSE = 'HANDLE_SHOP_NOTIFICATION_CLOSE',
}

export const initialState: StateType = {
  isMajorMenuOpen: false,
  isSecondaryMenuOpen: false,
  isDropdowMenuOpen: false,
  isLogoHidden: false,
  isBurgerOpen: false,
  isShopNotificationOpen: false,
}

type ActionType = {
  type: HeaderActionType
} & Partial<StateType>

export const headerReducer = (state: StateType, action: ActionType) => {
  switch (action.type) {
    case HeaderActionType.HANDLE_DROPDOWN_CLOSE:
      return {
        ...state,
        isDropdowMenuOpen: false,
        isMajorMenuOpen: false,
        isSecondaryMenuOpen: false,
        isBurgerOpen: false,
        isShopNotificationOpen: false,
      }

    // OPEN 地獄
    case HeaderActionType.HANDLE_MAJOR_OPEN:
      return {
        ...state,
        isMajorMenuOpen: !state.isMajorMenuOpen,
        isSecondaryMenuOpen: false,
        isShopNotificationOpen: false,
        isDropdowMenuOpen: !state.isMajorMenuOpen,
        isBurgerOpen: false,
      }
    case HeaderActionType.HANDLE_SECONDARY_OPEN:
      if (state.isShopNotificationOpen) {
        return {
          ...state,
          isShopNotificationOpen: false,
          isSecondaryMenuOpen: false,
          isDropdowMenuOpen: false,
          isBurgerOpen: false,
          isMajorMenuOpen: false,
        }
      }
      return {
        ...state,
        isSecondaryMenuOpen: !state.isSecondaryMenuOpen,
        isMajorMenuOpen: false,
        isShopNotificationOpen: false,
        isDropdowMenuOpen: !state.isSecondaryMenuOpen,
        isBurgerOpen: !state.isSecondaryMenuOpen,
      }
    case HeaderActionType.HANDLE_SHOP_NOTIFICATION_OPEN:
      return {
        ...state,
        isShopNotificationOpen: true,
        isMajorMenuOpen: false,
        isSecondaryMenuOpen: false,
        isDropdowMenuOpen: false,
        isBurgerOpen: true,
      }
    case HeaderActionType.HANDLE_SHOP_NOTIFICATION_CLOSE:
      return {
        ...state,
        isDropdowMenuOpen: false,
        isMajorMenuOpen: false,
        isSecondaryMenuOpen: false,
        isBurgerOpen: false,
        isShopNotificationOpen: false,
      }

    default:
      return state
  }
}
